export const DEFAULT_VIEW_TEMPLATE_ID_COLORLESS = 16;
export const DEFAULT_VIEW_TEMPLATE_ID_FANCY = 17;
export const DEFAULT_VIEW_TEMPLATE_ID_ROUGH = 15;
export const DEFAULT_VIEW_TEMPLATE_ID_JEWELRY = 15;
export const DEFAULT_VIEW_TEMPLATE_ID_COLORLESS_EDIT = 18;
export const DEFAULT_VIEW_TEMPLATE_ID_FANCY_EDIT = 19;
export const DEFAULT_VIEW_TEMPLATE_ID_ROUGH_EDIT = 20;
export const DEFAULT_VIEW_TEMPLATE_ID_JEWELRY_EDIT = 20;
